import { render, staticRenderFns } from "./RomanNumeration.vue?vue&type=template&id=8083534c&"
import script from "./RomanNumeration.vue?vue&type=script&lang=js&"
export * from "./RomanNumeration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports